"use client";
import Footer from '@/components/Footer';
import Header from '@/components/Header';
import PrivacyContent from './privacy.mdx';

export default function Privacy() {

    return (
        <div className={"page"}>
            <title>Apex Signals Privacy Policy</title>
            <Header />
            <main className={"main"}>
                <div className="pageCategory">Legal</div>
                <div className="pageTitle">Privacy and Cookies Policy</div>
                <div className="pageUpdatedTime">Last updated: 28 February 2025</div>
                <div className="pageBody" id="pageContents">
                    <PrivacyContent />
                </div>
            </main>
            <Footer />
        </div>
    );

}
